// docs: https://github.com/altostra/type-validations#readme
import { objectOf, arrayOf, anyOf } from "@altostra/type-validations";
import { number, string, nullValidation } from "@altostra/type-validations/lib/primitives";

export const isSinkLogsResult = objectOf({
  hits: number,
  results: arrayOf(
    objectOf({
      id: string,
      app_group_id: string,
      integration_id: string,
      integration_type: string,
      warehouse: string,
      job_id: string,
      error_type: anyOf(string, nullValidation), // Allow string or null
      error_message: anyOf(string, nullValidation), // Allow string or null
      id_values: anyOf(string, nullValidation), // Allow string or null
      payload: anyOf(string, nullValidation), // Allow string or null
      endpoint: anyOf(string, nullValidation), // Allow string or null
      error_timestamp: anyOf(string, nullValidation), // Allow string or null
      sf_created_at: string,
      updated_at: anyOf(string, nullValidation), // Allow string or null
    })
  ),
});
